module.exports = __webpack_public_path__ + "img/RadioGroup.9b390b5a.svg";